import apiRequest from 'Api/request'
import { OrderData } from 'Types/OrderData'

const getOrderData = (id: string): Promise<OrderData> =>
  apiRequest()
    .post('/order', { hash: id })
    .then(({ data }) => data)

export default getOrderData
